<!-- Email-task thread-as-body surface (sec 18). Only renders for email-origin tasks; a plain task's notes
     editor is rendered by the host modal directly (original layout) and never routed through here. The notes
     editor is projected in (flagged emailNotes) so it can sit in the collapsible "Task notes" card on top. -->
<div class="email-surface" *ngIf="hasEmail">

  <!-- Action bar -->
  <div class="email-actions">
    <button type="button" class="email-actions__btn" (click)="onReply('reply', $event)">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 17 4 12 9 7"/><path d="M20 18v-2a4 4 0 0 0-4-4H4"/></svg>
      Reply
      <!-- Story 5: amber warn when the linked contact has NO email on file (button stays enabled; the composer hosts the fix flow) -->
      <svg *ngIf="contactHasEmail === false" class="email-actions__warn" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" title="No email on file for the linked contact"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
    </button>
    <button type="button" class="email-actions__btn" (click)="onReply('replyAll', $event)">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="7 17 2 12 7 7"/><polyline points="12 17 7 12 12 7"/><path d="M22 18v-2a4 4 0 0 0-4-4H8"/></svg>
      Reply all
    </button>
    <button type="button" class="email-actions__btn" (click)="onReply('forward', $event)">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 17 20 12 15 7"/><path d="M4 18v-2a4 4 0 0 1 4-4h12"/></svg>
      Forward
    </button>
    <span class="email-actions__sep"></span>
    <button type="button" class="email-actions__btn" [class.email-actions__btn--on]="notesOpen" (click)="toggleNotes()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z"/></svg>
      {{ notesBtnLabel }}
    </button>
    <span class="email-actions__spacer"></span>
    <button type="button" class="email-actions__btn" *ngIf="email?.webLink" (click)="openInOutlook()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6"/></svg>
      Open in Outlook
    </button>
  </div>

  <!-- Scroll body -->
  <div class="email-scroll">

    <!-- Task notes card on top (collapsible). Kept mounted, toggled with [hidden] so the projected editor
         is never detached/re-attached. -->
    <div class="email-notes" [hidden]="!notesOpen">
      <div class="email-notes__head" (click)="toggleNotesCollapse()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6a7282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="email-notes__icon"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z"/></svg>
        <span class="email-notes__title">Task notes</span>
        <span class="email-notes__priv">Private to your team</span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="email-notes__chev" [class.email-notes__chev--collapsed]="notesCollapsed"><path d="m6 9 6 6 6-6"/></svg>
        <button type="button" class="email-notes__close" (click)="closeNotes($event)" aria-label="Hide notes">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>
      </div>
      <div class="email-notes__body" [hidden]="notesCollapsed">
        <ng-content select="[emailNotes]"></ng-content>
      </div>
    </div>

    <!-- Thread summary + meta (summary v2: lead-in sentence + purple-bullet brief; list hides when empty) -->
    <div class="email-summary" *ngIf="summaryText || summaryBullets.length">
      <div class="email-summary__head">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6d3bd4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.94 14.06A2 2 0 0 0 8.5 12.62l-5.6-1.45a.5.5 0 0 1 0-.96l5.6-1.45a2 2 0 0 0 1.44-1.44l1.45-5.6a.5.5 0 0 1 .96 0l1.45 5.6a2 2 0 0 0 1.44 1.44l5.6 1.45a.5.5 0 0 1 0 .96l-5.6 1.45a2 2 0 0 0-1.44 1.44l-1.45 5.6a.5.5 0 0 1-.96 0z"/></svg>
        <span class="email-summary__label">THREAD SUMMARY</span>
      </div>
      <p class="email-summary__text" *ngIf="summaryText">{{ summaryText }}</p>
      <div class="email-summary__bullets" *ngIf="summaryBullets.length">
        <div class="email-summary__bullet" *ngFor="let b of summaryBullets; trackBy: trackByBullet">
          <span class="email-summary__bullet-dot">•</span><span>{{ b }}</span>
        </div>
      </div>
      <!-- Adaptive metadata line (Story 4): Submitted {date} (form) / Received {date} (single email) /
           counts + last activity (thread), then the quiet sub-type chip, then the inbox token. -->
      <div class="email-summary__meta">
        <span *ngIf="metaMode === 'form'">Submitted<ng-container *ngIf="receivedDate"> {{ receivedDate | date: 'MMM d' }}</ng-container></span>
        <span *ngIf="metaMode === 'single'">Received<ng-container *ngIf="receivedDate"> {{ receivedDate | date: 'MMM d' }}</ng-container></span>
        <span *ngIf="metaMode === 'multi'">{{ messages.length }} {{ messages.length === 1 ? 'message' : 'messages' }}<ng-container *ngIf="participantCount"> · {{ participantCount }} {{ participantCount === 1 ? 'participant' : 'participants' }}</ng-container><ng-container *ngIf="lastActivity"> · last activity {{ lastActivity | date: 'MMM d' }}</ng-container></span>
        <ng-container *ngIf="subTypeChipLabel">
          <span class="email-summary__dot"></span>
          <span class="email-summary__chip">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8a93a0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/></svg>
            {{ subTypeChipLabel }}
          </span>
        </ng-container>
        <span class="email-summary__dot" *ngIf="inboxAddress"></span>
        <span class="email-summary__inbox" *ngIf="inboxAddress">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg>
          Inbox <strong>{{ inboxAddress }}</strong>
        </span>
      </div>
    </div>

    <!-- Thread status -->
    <div class="email-thread__status" *ngIf="threadLoading">Loading conversation…</div>
    <div class="email-thread__status email-thread__status--error" *ngIf="threadError && !threadLoading">{{ threadError }}</div>

    <!-- Messages (latest first) -->
    <div class="email-thread" *ngIf="messages.length">

      <!-- Story 6: active no-reply silence banner at the very top of the thread (newest position) -->
      <div class="email-noreply" *ngIf="activeBanner">
        <!-- No-reply alert (amber) -->
        <div class="email-noreply__card">
          <span class="email-noreply__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          </span>
          <div class="email-noreply__body">
            <div class="email-noreply__title">{{ activeBanner.bannerTitle }}</div>
            <div class="email-noreply__subtitle">{{ activeBanner.bannerSubtitle }}</div>
            <div class="email-noreply__actions">
              <button type="button" class="email-noreply__draft" (click)="draftFollowUp()">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.94 14.06A2 2 0 0 0 8.5 12.62l-5.6-1.45a.5.5 0 0 1 0-.96l5.6-1.45a2 2 0 0 0 1.44-1.44l1.45-5.6a.5.5 0 0 1 .96 0l1.45 5.6a2 2 0 0 0 1.44 1.44l5.6 1.45a.5.5 0 0 1 0 .96l-5.6 1.45a2 2 0 0 0-1.44 1.44l-1.45 5.6a.5.5 0 0 1-.96 0z"/></svg>
                Draft follow-up
              </button>
              <div style="position:relative;display:inline-flex;align-items:center;">
                <button type="button" class="email-noreply__wait" (click)="toggleWaitMenu($event)" [disabled]="followUpSaving">
                  Wait
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-left:4px;"><polyline points="6 9 12 15 18 9"/></svg>
                </button>
                <div *ngIf="waitMenuOpen" style="position:absolute;top:calc(100% + 4px);left:0;z-index:30;min-width:170px;background:#fff;border:1px solid #E5E7EB;border-radius:8px;box-shadow:0 6px 18px rgba(0,0,0,0.12);padding:4px;">
                  <button type="button" *ngFor="let w of waitPresetVms; trackBy: trackByWaitPreset" (click)="pickWait(w.value)"
                    style="display:flex;justify-content:space-between;gap:14px;width:100%;border:none;background:none;padding:6px 10px;font-size:13px;color:#374151;cursor:pointer;border-radius:6px;text-align:left;">
                    <span>{{ w.label }}</span><span style="color:#9CA3AF;">{{ w.dateLabel }}</span>
                  </button>
                  <button type="button" (click)="chooseCustom()"
                    style="display:block;width:100%;border:none;background:none;padding:6px 10px;font-size:13px;color:#374151;cursor:pointer;border-radius:6px;text-align:left;">
                    Custom date…
                  </button>
                </div>
                <vf-date-picker *ngIf="waitCustomOpen" class="email-noreply__wait-datepicker" variant="field"
                  placeholder="Pick a date" popoverAlign="right" [minDate]="waitMinDate" (dateChange)="pickWaitDate($event)"
                  style="margin-left:6px;"></vf-date-picker>
              </div>
            </div>
          </div>
          <button type="button" class="email-noreply__x" (click)="dismissFollowUp()" [disabled]="followUpSaving" title="Dismiss">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </button>
        </div>
        <!-- (confirm-mode card removed — §8.4: "Wait 3 more days" is now a single in-place ghost button) -->
      </div>

      <div class="email-thread__msg" [class.email-thread__msg--has-event]="eventChipsByMsgId[m.id]"
        *ngFor="let m of messages; trackBy: trackByMsg">

        <!-- Story 6: no-reply chip(s) anchored above the outbound this event guards (persists as history). -->
        <ng-container *ngIf="eventChipsByMsgId[m.id]">
          <div class="email-noreply-chip" *ngFor="let c of eventChipsByMsgId[m.id]; trackBy: trackByEvent">
            <span class="email-noreply-chip__line"></span>
            <span class="email-noreply-chip__pill">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              {{ c.chipText }}<span class="email-noreply-chip__suffix" *ngIf="c.chipSuffix">{{ c.chipSuffix }}</span>
            </span>
            <span class="email-noreply-chip__line"></span>
          </div>
        </ng-container>

        <div class="email-thread__head">
          <span class="email-thread__avatar" [class.email-thread__avatar--sent]="m.isSent">{{ messageInitial(m) }}</span>
          <div class="email-thread__who">
            <div class="email-thread__who-top">
              <span class="email-thread__who-name">{{ messageSenderName(m) }}</span>
              <span class="email-thread__badge" [class.email-thread__badge--sent]="m.isSent">{{ m.isSent ? 'Sent' : 'Received' }}</span>
              <span class="email-thread__badge email-thread__badge--latest" *ngIf="m.isLatest">Latest</span>
              <span class="email-thread__badge email-thread__badge--followup" *ngIf="isFollowUpMsg(m)">Follow-up</span>
              <span class="email-thread__badge email-thread__badge--newreply" *ngIf="isNewReplyMsg(m)">New reply</span>
              <svg *ngIf="m.hasAttachments" class="email-thread__clip" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" title="Has attachments"><path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
            </div>
            <div class="email-thread__sub">
              <span class="email-thread__to">to {{ toSummary(m) }}</span>
              <button type="button" class="email-thread__details-btn" (click)="toggleDetails(m, $event)">
                {{ detailsLabel(m) }}
                <svg class="email-thread__details-chev" [class.email-thread__details-chev--up]="isDetailsOpen(m)"
                  width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
                  stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </button>
            </div>
          </div>
          <span class="email-thread__date">{{ m.date | date: 'MMM d, y · h:mm a' }}</span>
        </div>

        <!-- Details (full recipient metadata) -->
        <div class="email-thread__details" *ngIf="isDetailsOpen(m)">
          <span class="email-thread__dlabel">From</span><span class="email-thread__dval">{{ messageSenderName(m) }} <span *ngIf="m.from">&lt;{{ m.from }}&gt;</span></span>
          <span class="email-thread__dlabel">To</span><span class="email-thread__dval">{{ m.to?.length ? m.to.join(', ') : '—' }}</span>
          <span class="email-thread__dlabel" *ngIf="m.cc?.length">Cc</span><span class="email-thread__dval" *ngIf="m.cc?.length">{{ m.cc.join(', ') }}</span>
          <span class="email-thread__dlabel" *ngIf="inboxLine(m)">Inbox</span><span class="email-thread__dval" *ngIf="inboxLine(m)">{{ inboxLine(m) }}</span>
          <span class="email-thread__dlabel" *ngIf="m.date">Date</span><span class="email-thread__dval" *ngIf="m.date">{{ m.date | date: 'MMM d, y, h:mm a' }}</span>
        </div>

        <!-- Saved-to-folder row for THIS message: sits between the address/details panel and the body
             (per design). Each email is filed to its own per-email SharePoint folder; the label shows
             "Email saved" or "Email + N attachments saved" when its attachments were filed too. -->
        <div class="email-filed email-filed--msg" *ngIf="m.filedFolderName">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6a7282" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" class="email-filed__check"><polyline points="20 6 9 17 4 12"/></svg>
          <span class="email-filed__text">{{ filedLabel(m) }}</span>
          <button type="button" class="email-filed__btn" *ngIf="canOpenMessageFolder(m)" (click)="openMessageFolder(m)">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6a7282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"/></svg>
            View in folder
          </button>
        </div>

        <!-- Body: full message in a sandboxed iframe (no scripts run). Borderless + auto-height: (load) resizes the
             frame to its content so the panel scrolls, never the frame. allow-same-origin (without allow-scripts) only
             lets the PARENT read the frame height; email JS still cannot execute. -->
        <div class="email-thread__bodywrap">
          <iframe class="email-thread__frame" *ngIf="bodyDoc(m)" [srcdoc]="bodyDoc(m)"
            sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox" referrerpolicy="no-referrer"
            scrolling="no" (load)="onFrameLoad($event)" [title]="messageSenderName(m)"></iframe>
        </div>

        <!-- Attachments (sec 18.3): real (non-inline) files on this message; click opens in-app (blob), not SharePoint. -->
        <div class="email-thread__atts" *ngIf="m.attachments && m.attachments.length">
          <button type="button" class="email-thread__att" *ngFor="let att of m.attachments; trackBy: trackByAtt"
            (click)="openAttachment(m, att)" [disabled]="attLoadingId === att.id" [title]="att.name">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
            <span class="email-thread__att-name">{{ att.name }}</span>
            <span class="email-thread__att-size" *ngIf="attSize(att.size)">· {{ attSize(att.size) }}</span>
          </button>
        </div>

      </div>

      <!-- Load earlier (sec 18.2): the newest messages show first; reveal earlier ones on demand. -->
      <button type="button" class="email-thread__more" *ngIf="hasMore" (click)="loadEarlier()" [disabled]="loadingMore">
        <span *ngIf="!loadingMore">Load {{ earlierCount }} earlier {{ earlierCount === 1 ? 'message' : 'messages' }}</span>
        <span *ngIf="loadingMore">Loading…</span>
      </button>
    </div>

  </div>

  <!-- Original-email reading view: full-fidelity render of the live body in a sandboxed iframe -->
  <div class="email-orig__backdrop" *ngIf="showOriginal" (click)="closeOriginal()">
    <div class="email-orig__panel" (click)="$event.stopPropagation()">
      <div class="email-orig__head">
        <span class="email-orig__title">{{ email?.subject || 'Original email' }}</span>
        <div class="email-orig__head-actions">
          <button type="button" class="email-orig__link" *ngIf="email?.webLink" (click)="openInOutlook()">
            <lucide-icon name="external-link" [size]="14" [strokeWidth]="2"></lucide-icon>
            Open in Outlook
          </button>
          <button type="button" class="email-orig__close" (click)="closeOriginal()" aria-label="Close">&times;</button>
        </div>
      </div>
      <div class="email-orig__body">
        <div class="email-orig__msg" *ngIf="originalLoading">Loading…</div>
        <div class="email-orig__msg" *ngIf="originalError && !originalLoading">{{ originalError }}</div>
        <iframe *ngIf="originalHtml && !originalLoading && !originalError"
          class="email-orig__frame" [srcdoc]="originalHtml"
          sandbox="allow-popups allow-popups-to-escape-sandbox" referrerpolicy="no-referrer"
          title="Original email"></iframe>
      </div>
    </div>
  </div>
</div>
